import { render, staticRenderFns } from "./NichesHeader.vue?vue&type=template&id=32ed9846"
import script from "./NichesHeader.vue?vue&type=script&lang=js"
export * from "./NichesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports